module.exports = __webpack_public_path__ + "static/carousel-dark2.3071e500.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel-dark2.jpg
// module id = 341
// module chunks = 35783957827783